export default function React_MultipleInputs() {
  return (
    <div>
      <h1>React_MultipleInputs Component</h1>
      <p>This is the React_MultipleInputs tutorial page.</p>
    </div>
  );
}
